import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMC_VIEW_OPTIONS } from './cmcCommandOptions';
import { CMD_CMCUSAGE_REGISTRY_KEY, META_TYPE as CMCUSAGE_META_TYPE, META_VER as CMCUSAGE_META_VER } from './cmcUsageCommandRegisteryType';
import {
    CMD_FEARGREED_REGISTRY_KEY,
    META_TYPE as FEARGREED_META_TYPE,
    META_VER as FEARGREED_META_VER,
} from './fearGreedCommandRegisteryType';
import { CMD_CMCASSET_REGISTRY_KEY, META_TYPE as CMCASSET_META_TYPE, META_VER as CMCASSET_META_VER } from './cmcAssetCommandRegisteryType';

/**
 * Registers the /cmc command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /cmc <view> — opens a cmc card by view name, e.g. /cmc usage, /cmc feargreed.
 */
export function registerCmcCommand() {
    commandEngine.register('/cmc', {
        hint: 'Open cmc widget',
        params: [{ name: 'view', options: CMC_VIEW_OPTIONS }],
        handler: ([view]) => {
            switch (view) {
                case 'fear':
                    cardPainterManager.openCard(CMD_FEARGREED_REGISTRY_KEY, {
                        type: FEARGREED_META_TYPE,
                        ver: FEARGREED_META_VER,
                        target: 'global',
                    });
                    break;
                case 'assets':
                    cardPainterManager.openCard(CMD_CMCASSET_REGISTRY_KEY, {
                        type: CMCASSET_META_TYPE,
                        ver: CMCASSET_META_VER,
                        target: 'global',
                    });
                    break;
                case 'usage':
                default:
                    cardPainterManager.openCard(CMD_CMCUSAGE_REGISTRY_KEY, {
                        type: CMCUSAGE_META_TYPE,
                        ver: CMCUSAGE_META_VER,
                        target: 'global',
                    });
                    break;
            }
        },
    });
}
